<template>
  <TransitionRoot
    :show="isOpen"
    as="template"
    enter="duration-300 ease-out"
    enter-from="opacity-0 scale-95"
    enter-to="opacity-100 scale-100"
    leave="duration-200 ease-in"
    leave-from="opacity-100 scale-100"
    leave-to="opacity-0 scale-95">
    <div
      class="cookie-notice fixed bottom-0 left-1/2 z-50 flex max-h-[60%] min-h-[152px] w-full max-w-[740px] -translate-x-1/2 flex-wrap gap-4 overflow-auto rounded-3xl bg-white p-6 shadow-even2xl md:bottom-6">
      <h2 class="w-full text-2xl">
        {{ $t('cookieNotice.title') }}
      </h2>
      <div class="flex flex-col items-end gap-4 md:flex-row md:items-start md:gap-6">
        <!-- eslint-disable vue/no-v-html -->
        <p
          class="w-auto font-normal text-gray-300"
          v-html="$t('cookieNotice.copy')" />
        <!-- eslint-enable vue/no-v-html -->
        <div class="flex flex-col gap-4 max-md:w-full">
          <FormButton
            :label="$t('cookieNotice.acceptLabel')"
            class="w-full"
            :kind="FormButtonKind.FILLED"
            @click="handleAcceptButtonClick()" />
          <FormButton
            :label="$t('cookieNotice.rejectLabel')"
            class="w-full"
            :kind="FormButtonKind.OUTLINED"
            @click="handleRejectButtonClick()" />
        </div>
      </div>
    </div>
  </TransitionRoot>
</template>

<script setup lang="ts">
  import { TransitionRoot } from '@headlessui/vue'

  import { CookiesConsentValue } from '~/constants/cookies'
  import { FormButtonKind } from '~/constants/form'

  const isOpen = ref(false)
  const { setCookiesConsent } = useCookiesConsent()

  onMounted(() => {
    open()
  })

  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  function handleAcceptButtonClick() {
    setCookiesConsent(CookiesConsentValue.YES)
    useMetaPixel()
    close()
  }

  function handleRejectButtonClick() {
    setCookiesConsent(CookiesConsentValue.NO)
    close()
  }
</script>
